/* JL 24.10.2026, Massnahmenplan Nr. 3c: Mitlaufende Kaufleiste (nur Handy, bis 749 px Breite). Ohne Fremdbibliothek, per defer geladen.
   Markup: snippets/jl-sticky-atc.liquid (nur Produktseiten der Vorlagen uhren-neu und schmuck, nicht bei ausverkauften Artikeln, nie Gebrauchtuhren).
   Verhalten: Die Leiste erscheint, sobald der Hauptbutton nach oben aus dem Bild gescrollt ist, und verschwindet am Seitenende (Footer sichtbar),
   bei deaktiviertem Hauptbutton (ausverkaufte Variante) und ab 750 px Breite. Der Button der Leiste loest den Hauptbutton aus (gleiches Formular, gleiche Variante).
   Der Text der Leiste wird vom Hauptbutton uebernommen (readLabel), damit beide immer gleich lauten, auch wenn der Text des Hauptbuttons spaeter geaendert wird.
   3d: Solange die Leiste sichtbar ist, steht die Klasse jl-sticky-on auf <html>. Der schwebende Knopf "Vertrag widerrufen" (App EU-Widerruf-Button,
   Element #wb-trigger-btn) wird gesucht (fest positioniert, unten, Name oder Text enthaelt "Widerruf") und per Attribut data-jl-widerruf markiert; assets/jl-kaufbereich.css rueckt ihn dann um die
   Hoehe der Leiste nach oben. Er wird weder entfernt noch verkleinert noch versteckt. */
(function () {
  'use strict';
  var bar = document.querySelector('[data-jl-sticky-atc]');
  if (!bar || bar.getAttribute('data-jl-ready')) return;
  var sid = bar.getAttribute('data-section-id');
  var main = document.getElementById('ProductSubmitButton-' + sid);
  if (!main) return;
  bar.setAttribute('data-jl-ready', '1');

  var stale = document.querySelectorAll('body > [data-jl-sticky-atc]');
  for (var i = 0; i < stale.length; i++) {
    if (stale[i] !== bar) stale[i].parentNode.removeChild(stale[i]);
  }
  /* Die Leiste liegt am Ende von <body>, damit kein Eltern-Element mit transform sie verschiebt. */
  document.body.appendChild(bar);

  var root = document.documentElement;
  var out = bar.querySelector('[data-jl-sticky-price]');
  var btn = bar.querySelector('[data-jl-sticky-btn]');
  var mq = window.matchMedia('(max-width: 749px)');
  var past = false;
  var atEnd = false;
  var shown = false;
  var tick = 0;
  var tries = 0;
  var widerruf = null;

  function readPrice() {
    var bp = document.querySelector('block-price[data-section-id="' + sid + '"]') || document.querySelector('block-price');
    if (!bp || !out) return;
    var box = bp.querySelector('.block-price__container');
    var el = null;
    if (box && box.hasAttribute('data-on-sale')) el = bp.querySelector('.block-price__sale > span.product__price > span[aria-hidden="true"]');
    if (!el) el = bp.querySelector('.block-price__regular > span:not(.visually-hidden) > span[aria-hidden="true"]');
    if (!el) return;
    var txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (txt && out.textContent !== txt) out.textContent = txt;
  }

  function readLabel() {
    if (!btn || main.disabled) return;
    var s = main.querySelector('span') || main;
    var txt = (s.textContent || '').replace(/\s+/g, ' ').trim();
    if (!txt || btn.textContent === txt) return;
    btn.textContent = txt;
    var title = bar.getAttribute('data-jl-title');
    btn.setAttribute('aria-label', title ? txt + ': ' + title : txt);
  }

  function isFixedLow(el) {
    try {
      if (window.getComputedStyle(el).position !== 'fixed') return false;
      var r = el.getBoundingClientRect();
      return r.height > 0 && r.top > window.innerHeight * 0.5;
    } catch (e) {
      return false;
    }
  }

  function findWiderruf() {
    if (widerruf && root.contains(widerruf)) return;
    widerruf = null;
    var nodes = document.body.querySelectorAll('*');
    for (var n = 0; n < nodes.length; n++) {
      var el = nodes[n];
      if (el === bar || bar.contains(el)) continue;
      var s = (el.id || '') + ' ' + (typeof el.className === 'string' ? el.className : '') + ' ' + (el.getAttribute('href') || '') + ' ' +
        (el.getAttribute('aria-label') || '') + ' ' + (el.getAttribute('title') || '') + ' ' + (el.getAttribute('src') || '');
      var hit = /widerruf|withdraw/i.test(s);
      if (!hit && el.children.length === 0) {
        var t = (el.textContent || '').trim();
        hit = t.length > 0 && t.length < 40 && /widerruf/i.test(t);
      }
      if (!hit) continue;
      var p = el;
      while (p && p !== document.body) {
        if (isFixedLow(p)) {
          p.setAttribute('data-jl-widerruf', '');
          widerruf = p;
          return;
        }
        p = p.parentElement;
      }
    }
  }

  function update() {
    var want = mq.matches && past && !atEnd && !main.disabled;
    if (want === shown) return;
    shown = want;
    bar.classList.toggle('is-visible', want);
    root.classList.toggle('jl-sticky-on', want);
    if (want) {
      findWiderruf();
      if (!widerruf && tries < 4) {
        tries++;
        window.setTimeout(findWiderruf, 1500);
      }
    }
  }

  function schedule() {
    if (tick) return;
    tick = window.requestAnimationFrame(function () {
      tick = 0;
      readPrice();
      readLabel();
      update();
    });
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      past = !e.isIntersecting && e.boundingClientRect.bottom < 0;
      update();
    }).observe(main);

    /* Footer-Bereiche: nur Abschnitte mit echter Hoehe zaehlen (ein Abschnitt ohne Hoehe am Seitenanfang gilt sonst als "sichtbar"). */
    var feet = document.querySelectorAll('.shopify-section-group-footer-group');
    if (!feet.length) {
      var f = document.querySelector('footer');
      feet = f ? [f] : [];
    }
    if (feet.length) {
      var seen = new Map();
      var fio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.boundingClientRect.height > 0) seen.set(e.target, e.isIntersecting);
          else seen.delete(e.target);
        });
        atEnd = false;
        seen.forEach(function (v) { if (v) atEnd = true; });
        update();
      });
      for (var k = 0; k < feet.length; k++) fio.observe(feet[k]);
    }
  }

  if (window.MutationObserver) {
    var scope = main.closest('.product-single__meta') || document.body;
    new MutationObserver(schedule).observe(scope, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'data-on-sale', 'data-sold-out']
    });
  }

  if (mq.addEventListener) mq.addEventListener('change', update);
  else if (mq.addListener) mq.addListener(update);

  if (btn) {
    btn.addEventListener('click', function () {
      if (!main.disabled) main.click();
    });
  }

  readPrice();
  readLabel();
  update();
})();